import { AccountDetail, CustomerGroup } from '@/contexts/AuthContext/useNango';
import styles from './GoogleAdsAccounts.module.scss';


interface GoogleAdsAccountsProps {
    availableCustomers: CustomerGroup[];
    accountsLoading: boolean;
    hasFetchedAccounts: boolean;
}

export default function GoogleAdsAccounts({
    availableCustomers, accountsLoading, hasFetchedAccounts 
}: GoogleAdsAccountsProps) {

    // Account row component
    const AccountRow = ({ account, groupManagerId }: { account: AccountDetail, groupManagerId: string }) => {

        return (
            <div className={`${styles.accountRow}`}>
                <div className={styles.accountInfo}>
                    <div className={styles.accountTextCol}>
                        <div className={styles.accountNameText}>
                            {account.name}
                            <span style={{ opacity: 0.5, marginLeft: '8px' }}>
                                - 
                                {' '}
                                {account.account_id}
                            </span>
                        </div>

                        {(account.currency_code || account.timezone) ? (
                            <div className={styles.accountDetails}>
                                {account.currency_code}
                                {account.timezone ? `• ${account.timezone}` : ''}
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    };

    // Loading state
    if (accountsLoading) {
        return (
            <div className={styles.loadingState}>
                <p>Loading Google Ads Accounts...</p>
            </div>
        );
    }

    // Empty state
    if (!hasFetchedAccounts || availableCustomers.length === 0) {
        return (
            <div className={styles.emptyState}>
                <p>No accessible Google Ads accounts found.</p>
            </div>
        );
    }

    return (
        <div className={styles.accountsContainer}>
            {availableCustomers.map((group) => (
                <div className={styles.card} key={group.account_id}>
                    <div className={styles.cardHeader}>
                        Account - 
                        {' '}
                        {group.account_id}
                    </div>

                    <div className={styles.cardBody}>
                        {group.accounts.map(account => (
                            <AccountRow
                                key={account.account_id}
                                account={account}
                                groupManagerId={group.account_id}
                            />
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
}
